import axios from 'axios';

export default function (context, val) {
    let id = val.RegularPaymentId ? val.RegularPaymentId : val.Id;
    window.app.$confirm('Вы действительно хотите удалить требование?', 'Удаление требования №' + id, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        context.commit('remove', val);
        axios({
            method: 'post',
            url: '/tourclient/payment/deleteRegular',
            data: 'id=' + id,
            requestId: 'tourclient/payment/deleteRegular',
        }).then(r => {
            if(val.callback)val.callback();
            window.app.$message({
                type: 'success',
                message: 'Требование удалено'
            });
        }).catch(e => {
        })
    }).catch(() => {
    });
}